export default "__VITE_ASSET__DVvmvp3Z__"